import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";

/* eslint-disable no-restricted-syntax */

/**
 * Detect weather
 */
var canAbortFetch = null; // Window cannot be used in web worker

try {
  canAbortFetch = 'AbortController' in window;
} catch (_) {
  canAbortFetch = null;
}
/**
 * Default response type for module
 */


var DEFAULT_RESP_TYPE = 'json';
/**
 * Default timeout time
 */

var DEFAULT_TIMEOUT = 30000; // 30s

var globalDefaultOptions = {};
/**
 *  Get an check the responseType user sets.
 */

var getResponseType = function getResponseType(type) {
  var validType = String(type).toLowerCase();
  var types = {
    json: true,
    text: true,
    formData: true,
    blob: true,
    arrayBuffer: true
  };
  return types[validType] ? validType : DEFAULT_RESP_TYPE;
};

var defaultValidateStatus = function defaultValidateStatus(status) {
  return status >= 200 && status < 300;
};
/**
 * Fetch class used to create new fetch instance
 *
 * @author lucky.zhou
 * @class
 */


var Fetch = /*#__PURE__*/function () {
  function Fetch() {
    var defaultConfig = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var settings = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, Fetch);

    this.defaultOpts = _objectSpread(_objectSpread({}, globalDefaultOptions), defaultConfig);
    this.timeout = settings.timeout || DEFAULT_TIMEOUT;
    this.validateStatus = settings.validateStatus || defaultValidateStatus;
    this.defaultRespType = settings.defaultRespType || DEFAULT_RESP_TYPE;
    this.interceptors = {
      response: [],
      request: [],
      errorHandler: [],
      finally: []
    };
  }

  _createClass(Fetch, [{
    key: "get",
    value: function get(url) {
      var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var respType = arguments.length > 2 ? arguments[2] : undefined;
      var nUrl = url;

      if (opts.body) {
        var params = opts.body;
        var keys = Object.keys(params);
        keys.forEach(function (key) {
          var param = "".concat(key, "=").concat(params[key]);
          nUrl = nUrl.indexOf('?') > -1 ? "".concat(nUrl, "&").concat(param) : "".concat(nUrl, "?").concat(param);
        });
        delete opts.body;
      }

      return this.fetch(nUrl, _objectSpread(_objectSpread({}, opts), {}, {
        method: 'get'
      }), respType);
    }
  }, {
    key: "post",
    value: function post(url) {
      var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var respType = arguments.length > 2 ? arguments[2] : undefined;
      return this.fetch(url, _objectSpread(_objectSpread({}, opts), {}, {
        method: 'post'
      }), respType);
    }
  }, {
    key: "delete",
    value: function _delete(url) {
      var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var respType = arguments.length > 2 ? arguments[2] : undefined;
      return this.fetch(url, _objectSpread(_objectSpread({}, opts), {}, {
        method: 'delete'
      }), respType);
    }
  }, {
    key: "put",
    value: function put(url) {
      var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var respType = arguments.length > 2 ? arguments[2] : undefined;
      return this.fetch(url, _objectSpread(_objectSpread({}, opts), {}, {
        method: 'put'
      }), respType);
    }
    /**
     * Base function for using default fetch
     *
     * @param {string} url The request url
     * @param {object} options The request options
     *
     * @description
     * `options` follow the w3c fetch options structure
     * `meta` in `options` used to pass meta info.
     *
     * @returns {Promise} The request promise
     */

  }, {
    key: "fetch",
    value: function (_fetch) {
      function fetch(_x) {
        return _fetch.apply(this, arguments);
      }

      fetch.toString = function () {
        return _fetch.toString();
      };

      return fetch;
    }(function (url) {
      var _this = this;

      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var respType = arguments.length > 2 ? arguments[2] : undefined;
      var respContentType = respType || this.defaultRespType;

      var opts = _objectSpread(_objectSpread(_objectSpread({
        url: url
      }, this.defaultOpts), options), {}, {
        headers: _objectSpread(_objectSpread({}, this.defaultOpts.headers), options.headers)
      }); // to use chained options in interceptors array


      var hackedOpts = this.interceptors.request.reduce(function (prev, cur) {
        return cur(prev, url);
      }, opts);
      var timeoutTimer;
      var fetchController = canAbortFetch ? new AbortController() : {};
      hackedOpts.signal = fetchController.signal;
      /**
       * timeout promise to abort request if necessary
       */

      var abortPromise = new Promise(function (resolve, reject) {
        timeoutTimer = setTimeout(function () {
          // Must reject first here!
          // eslint-disable-next-line
          reject({
            ret_code: 9000001,
            ret_msg: 'Request timeout, please re-try!',
            url: url
          });
          /* istanbul ignore next */

          if (canAbortFetch) fetchController.abort();
        }, _this.timeout);
      });
      /**
       * real fetch request promise
       */

      var fetchPromise = fetch(url, hackedOpts);
      return Promise.race([fetchPromise, abortPromise]) // 1. clear timeout timer
      .then(function (resp) {
        clearTimeout(timeoutTimer);
        return resp;
      }) // 2. transform response data type and return
      .then(function (resp) {
        if (!_this.validateStatus(resp.status)) {
          return Promise.reject({
            status: resp.status,
            statusText: resp.statusText
          });
        }

        if (resp.ok) {
          return new Promise(function (resolve) {
            resp[getResponseType(respContentType)]().then(function (res) {
              resolve({
                headers: resp.headers,
                data: res
              });
            });
          });
        }

        return {
          headers: {},
          data: {}
        };
      }) // 3. handle response interceptors transform and return new data
      .then(function (_ref) {
        var data = _ref.data,
            headers = _ref.headers;
        return _this.interceptors.response.reduce(function (prev, cur) {
          return prev.then(cur);
        }, Promise.resolve({
          headers: headers,
          data: data,
          config: hackedOpts,
          url: url
        }));
      }).catch(function (err) {
        clearTimeout(timeoutTimer);

        _this.interceptors.errorHandler.forEach(function (fn) {
          return fn(err, hackedOpts, url);
        }); // throw err;


        return Promise.reject(err);
      }).finally(function () {
        _this.interceptors.finally.forEach(function (fn) {
          return fn(hackedOpts, url);
        });
      });
    })
  }]);

  return Fetch;
}();
/**
 * Fetch instance factory function
 *
 * @param {object} cfg The request options for every request
 * @param {object} settings The fetch settings for controller
 */


var createFetchInstance = function createFetchInstance() {
  var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var settings = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  /* istanbul ignore next */
  if (typeof window === 'undefined' || !('fetch' in window)) {
    // eslint-disable-next-line
    console && console.error && console.error('fetch function doesn\'t detected in you environment'); // return null;
  }

  var instance = new Fetch(opts, settings);
  var rawFetch = instance.fetch.bind(instance);
  rawFetch.get = instance.get.bind(instance);
  rawFetch.post = instance.post.bind(instance);
  rawFetch.put = instance.put.bind(instance);
  rawFetch.delete = instance.delete.bind(instance);
  rawFetch.interceptors = instance.interceptors;
  return rawFetch;
};

export default createFetchInstance;